<div class="padding5 search-wrapper">
  <ion-input [debounce]="debounce" mode="md" [disabled]="disabled" [label]="label" labelPlacement="floating"
    [minlength]="minLength" [maxlength]="maxLength" (keyup.enter)="keyEnter()" [type]="type" [placeholder]="label"
    (ionChange)="editInput()" (ionBlur)="checkFocus()" (paste)="onPaste($event)" [(ngModel)]="variable"
    [clearInput]="clearInput" (ionInput)="onTypeIn()" fill="outline"></ion-input>

  <ion-icon *ngIf="icon && variable && variable.length > 1" [name]="icon" class="search-icon" (click)="onIconClick()"></ion-icon>

  <div class="validationError" *ngIf="validationMessage">
    {{ validationMessage }}
  </div>
</div>